import {memo, useCallback, useState, Suspense} from 'react'

import type {TestId} from '../../../../types'
import GroupBy from '../../../common/GroupBy/GroupBy'
import InvestigationStatusFilter from '../../../common/InvestigationStatusFilter/InvestigationStatusFilter'
import MuteStatusFilter from '../../../common/MuteStatusFilter/MuteStatusFilter'

import TestProblemList from './TestProblemList/TestProblemList'

import styles from './TestProblems.css'

type Props = {
  projectId: string
}
function TestProblems({projectId}: Props) {
  const [selectedIds, setSelectedIds] = useState<TestId[]>([])

  const onSelectedIdsChange = useCallback((ids: TestId[]) => {
    setSelectedIds(ids)
  }, [])

  const onClearSelection = useCallback(() => {
    setSelectedIds([])
  }, [])

  return (
    <>
      <div className={styles.row}>
        <GroupBy />
        <MuteStatusFilter onChange={onClearSelection} />
        <InvestigationStatusFilter onChange={onClearSelection} />
      </div>
      <Suspense>
        <TestProblemList
          projectId={projectId}
          selectedIds={selectedIds}
          onSelectedIdsChange={onSelectedIdsChange}
        />
      </Suspense>
    </>
  )
}

export default memo(TestProblems)
